import { TemplatePage } from './types';

const live_streaming_halloween_theme: TemplatePage = {
  header: {
    color: '#C7EDFA',
    icon: 'images/video-templates/thanksgiving.jpg',
    title: 'Live Stream Templates — Thanksgiving Theme',
    title_meta: 'Free Thanksgiving Live Stream Overlay Templates',
    description_meta:
      'Make your holiday live stream extra special with editable Thanksgiving-themed overlay templates.' +
      ' Try them now — easy & free!',
    description:
      'Make your holiday live stream extra special with our collection of editable Thanksgiving-themed' +
      ' overlay templates. Create a cozy-looking countdown, intro & outro, lower third, and overlay for' +
      ' your live stream with minimum effort.'
  },
  footer: {
    category: 'Live Stream Thanksgiving Theme',
    description:
      'With Wave.video’s autumnal collection of easy-to-personalize templates, you can create pro-looking' +
      ' branded live stream overlays and screens in a matter of minutes. Impress and engage your online' +
      ' audience with Thanksgiving-themed countdowns, intros, outros, thumbnails, and lower thirds without' +
      ' having any professional design experience. Step up your live streaming game this holiday season and' +
      ' immediately reap the rewards of your efforts!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Thanksgiving Theme',
      search: { name: 'ThanksgivingTheme', tags: 'ThanksgivingTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_halloween_theme;
